import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideFirebaseApp } from '@angular/fire/app';
import { provideAuth } from '@angular/fire/auth';
import { provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { provideFirestore } from '@angular/fire/firestore';
import { provideFunctions } from '@angular/fire/functions';
import { provideMessaging } from '@angular/fire/messaging';
import { providePerformance } from '@angular/fire/performance';
import { provideStorage } from '@angular/fire/storage';
import { provideRemoteConfig } from '@angular/fire/remote-config';
import { provideVertexAI } from '@angular/fire/vertexai';
import { provideAppCheck } from '@angular/fire/app-check';
import { getAuth } from '@angular/fire/auth';
import { getAnalytics } from '@angular/fire/analytics';
import { getFirestore } from '@angular/fire/firestore';
import { getFunctions } from '@angular/fire/functions';
import { getMessaging } from '@angular/fire/messaging';
import { getPerformance } from '@angular/fire/performance';
import { getStorage } from '@angular/fire/storage';
import { getRemoteConfig } from '@angular/fire/remote-config';
import { getVertexAI } from '@angular/fire/vertexai';
import { getApp } from 'firebase/app';
import { provideHttpClient, HttpClient, withInterceptors } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor } from '../interceptor/auth.interceptor';
import {
  getOrInitFirebaseApp,
  initAppCheck,
} from './firebase.config';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/i18n/', '.json'); 
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
    provideFirebaseApp(() => getOrInitFirebaseApp()),
    provideAppCheck(() => {
      const appCheck = initAppCheck(getApp());
      if (!appCheck) {
        throw new Error('App Check is not available in this environment.');
      }
      return appCheck;
    }),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    providePerformance(() => getPerformance()),
    provideStorage(() => getStorage()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideVertexAI(() => getVertexAI()),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        fallbackLang: 'pt'
      })
    )
  ]
};
